import { render, staticRenderFns } from "./mobile-user-review.vue?vue&type=template&id=5a292176&"
import script from "./mobile-user-review.vue?vue&type=script&lang=js&"
export * from "./mobile-user-review.vue?vue&type=script&lang=js&"
import style0 from "./mobile-user-review.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports